import { createSelector } from 'reselect';
import { getLoginState } from 'src/modules/login/selectors/getLoginState';

export const getIsAuthenticated = createSelector([
  getLoginState,
], (state) => state.user !== null);
